// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfc_a"};